export enum RequestManagement {
    Mine = 'Mine',
    Favourites = 'Favourites',
    AdvancedSearch = 'AdvancedSearch'
}